'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const BackButtonWrapper = styled__default["default"].button.withConfig({
  componentId: "sc-8zpb35-0"
})(["position:relative;width:40px;height:40px;background:transparent;border:0 none;cursor:pointer;"]);
const Bar = styled__default["default"].div.withConfig({
  componentId: "sc-8zpb35-1"
})(["width:10px;height:2px;background:black;position:absolute;transform:rotate(-45deg);border-radius:2px;top:15px;left:14px;"]);
const BarReverse = styled__default["default"](Bar).withConfig({
  componentId: "sc-8zpb35-2"
})(["transform:rotate(45deg);top:21px;"]);

exports.BackButtonWrapper = BackButtonWrapper;
exports.Bar = Bar;
exports.BarReverse = BarReverse;
